import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useContent } from "@/context/ContentContext";
import { useLang } from "@/context/LanguageContext";

export const Footer = () => {
  const { content } = useContent();
  const { t, L } = useLang();
  const c = content?.contact || {};
  const loc = content?.location || {};
  const waLink = `https://wa.me/${(c.whatsapp || "").replace(/[^0-9]/g, "")}`;

  return (
    <footer className="bg-ocean-900 text-sand-100/80" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <Logo variant="light" className="h-16 w-auto mb-4" />
          <p className="text-sm leading-relaxed text-sand-100/60 max-w-xs">
            {L(content?.brand?.tagline) || "Surf club & community · Isola delle Femmine, Palermo."}
          </p>
        </div>

        <div>
          <h4 className="font-mono text-xs tracking-[0.2em] text-gold mb-4">{t("footer.contacts")}</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={waLink} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 hover:text-gold transition-colors">
                <MessageCircle className="w-4 h-4" /> WhatsApp
              </a>
            </li>
            <li>
              <a href={`tel:${c.phone}`} data-testid="footer-phone" className="flex items-center gap-2 hover:text-gold transition-colors">
                <Phone className="w-4 h-4" /> {c.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${c.email}`} data-testid="footer-email" className="flex items-center gap-2 hover:text-gold transition-colors">
                <Mail className="w-4 h-4" /> {c.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs tracking-[0.2em] text-gold mb-4">{t("footer.social")}</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={c.instagram_url || "#"} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex items-center gap-2 hover:text-gold transition-colors">
                <Instagram className="w-4 h-4" /> {c.instagram || "Instagram"}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0" /> <span>{L(loc.address)}</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs tracking-[0.2em] text-gold mb-4">{t("footer.legal")}</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-gold transition-colors">{t("footer.privacy")}</Link></li>
            <li><Link to="/cookie" data-testid="footer-cookie" className="hover:text-gold transition-colors">{t("footer.cookie")}</Link></li>
            <li><Link to="/admin/login" className="text-sand-100/40 hover:text-gold transition-colors text-xs">{t("footer.admin")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 py-5 text-xs text-sand-100/50 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Salty Folks Surf Club. All rights reserved.</span>
          <span>Isola delle Femmine · Palermo · Sicily</span>
        </div>
      </div>
    </footer>
  );
};
